// ** Handle User Login
import {store} from "../../index";

export const handleLogin = token => {
    return dispatch => {
        dispatch({
            type: 'LOGIN',
            payload: token
        })

        // ** Add to user, accessToken & refreshToken to localStorage
        localStorage.setItem('token', token)
    }
}


// ** Handle User Logout
export const handleLogout = () => {
    return dispatch => {
        dispatch({type: 'LOGOUT'})
        // ** Remove user, accessToken & refreshToken from localStorage
        localStorage.removeItem('token')
    }
}


// ** Handle OTP CountDown
/*export const handleOtpCountDown = () => {
    console.log("lets dispatch")
    setInterval(function () {
        console.log('increment timer')
        store.dispatch({
            type: 'OtpCountDown'
        })
    }, 1000)
}*/
